import { iData, iRawTweet } from './Types'


const getKpis = (data: iRawTweet[]) => Object.values(data.reduce((d, i) => {
    const created_at = new Date(i.created_at)
    created_at.setUTCHours(0)
    created_at.setUTCMinutes(0)
    created_at.setUTCSeconds(0)
    created_at.setUTCMilliseconds(0)
    
    const date = Number(new Date(created_at))

    return {
        ...d,
        [date]: d[date]
            ?
                {
                    date: d[date].date,
                    Tweets: d[date].Tweets + Number(i.text[0] !== '@'),
                    Comments: d[date].Comments + Number(i.text[0] === '@'),
                    Likes: d[date].Likes + i.organic_metrics.like_count,
                    Impressions: d[date].Impressions + i.organic_metrics.impression_count,
                    Visits: d[date].Visits + i.organic_metrics.user_profile_clicks,
                    Retweets: d[date].Retweets + i.organic_metrics.retweet_count,
                    Replies: d[date].Replies + i.organic_metrics.reply_count        
                }
            :
                {
                    date: String(new Date(date)),
                    Tweets: Number(i.text[0] !== '@'),
                    Comments: Number(i.text[0] === '@'),
                    Likes: i.organic_metrics.like_count,
                    Impressions: i.organic_metrics.impression_count,
                    Visits: i.organic_metrics.user_profile_clicks,
                    Retweets: i.organic_metrics.retweet_count,
                    Replies: i.organic_metrics.reply_count        
                }
    }
}, {} as { 
    [n: number]: { 
        date: string, 
        Tweets: number, 
        Comments: number, 
        Likes: number, 
        Impressions: number, 
        Visits: number, 
        Retweets: number, 
        Replies: number 
    }
}) ).map(({ date, Tweets, Comments, Likes, Impressions, Visits, Retweets, Replies }) => ({ 
    date: date, 
    kpis: { Tweets, Comments, Likes, Impressions, Visits, Retweets, Replies }
}))



const getMentions = (data: iRawTweet[]) => Object.entries(data.filter(({ text }) => text[0] === '@').reduce((d, i) => ({ 
    ...d, 
    [i.text.split(' ')[0]]: {
        Tweets: d[i.text.split(' ')[0]] ? d[i.text.split(' ')[0]].Tweets + 1: 1,
        Comments: d[i.text.split(' ')[0]] ? d[i.text.split(' ')[0]].Tweets + 1: 1,
        Likes: d[i.text.split(' ')[0]] ?  d[i.text.split(' ')[0]].Likes + i.organic_metrics.like_count : i.organic_metrics.like_count,
        Impressions: d[i.text.split(' ')[0]] ?  d[i.text.split(' ')[0]].Impressions + i.organic_metrics.impression_count : i.organic_metrics.impression_count,
        Visits: d[i.text.split(' ')[0]] ?  d[i.text.split(' ')[0]].Visits + i.organic_metrics.user_profile_clicks : i.organic_metrics.user_profile_clicks,
        Retweets: d[i.text.split(' ')[0]] ?  d[i.text.split(' ')[0]].Retweets + i.organic_metrics.retweet_count : i.organic_metrics.retweet_count,
        Replies: d[i.text.split(' ')[0]] ?  d[i.text.split(' ')[0]].Replies + i.organic_metrics.reply_count : i.organic_metrics.reply_count
    }
}), {} as { 
    [n: string]: {
        Tweets: number, 
        Comments: number,
        Likes: number, 
        Impressions: number, 
        Visits: number, 
        Retweets: number, 
        Replies: number 
    }
}))
.map(([ k, v]) => ({ name: k, kpis: v}))




const getTopics = (data: iRawTweet[]) => Object.entries(
    data.filter(({ text }) => text[0] !== '@').filter(({ text }) => text.includes('#'))
    .reduce((d, i) => [
        ...d, 
        i.text
        .split(/ |\n/)
        .filter(w => w[0] === '#')
        .map(w => ({ name: w, tweet: i}))
    ], [] as {name: string, tweet: iRawTweet}[][])
    .reduce((d, i) => [...d, ...i], [] as {name: string, tweet: iRawTweet}[])
    .reduce((d, i) => ({ 
            ...d, 
            [i.name] : d[i.name] 
            ?   { 
                    Tweets: d[i.name].Tweets + 1, 
                    Likes: d[i.name].Likes + i.tweet.organic_metrics.like_count, 
                    Impressions: d[i.name].Impressions + i.tweet.organic_metrics.impression_count, 
                    Visits: d[i.name].Visits + i.tweet.organic_metrics.user_profile_clicks,
                    Retweets: d[i.name].Retweets + i.tweet.organic_metrics.retweet_count,
                    Replies: d[i.name].Replies + i.tweet.organic_metrics.reply_count
                }
            :   { 
                    Tweets: 1,
                    Likes: i.tweet.organic_metrics.like_count,
                    Impressions: i.tweet.organic_metrics.impression_count,
                    Visits: i.tweet.organic_metrics.user_profile_clicks,
                    Retweets: i.tweet.organic_metrics.retweet_count,
                    Replies: i.tweet.organic_metrics.reply_count
            }
        }), {} as { 
            [n: string]: {
                Tweets: number, 
                Likes: number, 
                Impressions: number, 
                Visits: number, 
                Retweets: number, 
                Replies: number 
            }
        } 
    )
).map(([ k, v]) => ({ name: k, kpis: {...v, Comments: v.Tweets }}))


const getTweets = (data: iRawTweet[]) => data.map(({ text, organic_metrics, created_at }) => ({
    text,
    created_at,
    kpis:{
        Tweets: Number(text[0] === '@'),
        Comments: Number(text[0] !== '@'),
        Likes: organic_metrics.like_count,
        Impressions: organic_metrics.impression_count,
        Visits: organic_metrics.user_profile_clicks,
        Retweets: organic_metrics.retweet_count,
        Replies: organic_metrics.reply_count
    }
}))


interface iSetData { userId: string, userName: string, tweets: iRawTweet[] }
export const parseTweets = ({userName, userId, tweets}: iSetData): iData => ({
    userId: userId,
    userName: userName,
    kpis: getKpis(tweets),
    mentions: getMentions(tweets),
    topics: getTopics(tweets),
    tweets: getTweets(tweets),
    paying: false
})
